import { render, staticRenderFns } from "./update-product.vue?vue&type=template&id=409ace1a&scoped=true"
import script from "./update-product.vue?vue&type=script&lang=ts"
export * from "./update-product.vue?vue&type=script&lang=ts"
import style0 from "./update-product.vue?vue&type=style&index=0&id=409ace1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409ace1a",
  null
  
)

export default component.exports